import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@common-ui-library/atom';
import { logger, useI18n, useBIEvents } from '@common-ui-library/shared';
import { EleosLogo } from '@common-ui-library/molecule';
import { BASE_URL } from '../Utils/utils';
import { BI_NOT_FOUND_PAGE_VIEW } from '../Utils/biEvents';

interface NotFoundPageProps {
  fullPage?: boolean;
}

export const NotFoundPage: React.FC<NotFoundPageProps> = ({ fullPage = false }) => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { sendBIEvent } = useBIEvents();

  useEffect(() => {
    logger.error('NotFoundPage rendered - Page not found', { fullPage, path: window.location.pathname });
    
    // Emit BI event
    sendBIEvent(BI_NOT_FOUND_PAGE_VIEW, {
      path: window.location.pathname
    });
  }, [sendBIEvent]);

  const handleGoHome = () => {
    navigate(BASE_URL);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: fullPage ? '100vh' : '60vh',
        bgcolor: fullPage ? 'background.default' : 'transparent',
        p: 3,
        textAlign: 'center',
      }}
    >
      {fullPage && (
        <Box sx={{ mb: 4 }}>
          <EleosLogo />
        </Box>
      )}
      <Typography variant="h4" gutterBottom>
        {t('errors.pageNotFound')}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 400 }}>
        {t('errors.pageNotFoundMessage')}
      </Typography>
      <Button variant="contained" color="primary" onClick={handleGoHome}>
        {t('actions.goToHome')}
      </Button>
    </Box>
  );
};

